import { useState, useEffect } from "react";
import { Checkbox, FormControlLabel, Typography, Stack } from "@mui/material";
import PropTypes from 'prop-types';
import SelectPoste from "./selectPoste";

function Vendredi({ data_vendredi, onVendrediChange, triggerResetVendredi }) {

  const [vendredi, setVendredi] = useState({
    c_09_12: '',
    c_15_17: '',
    c_17_22: '',
    repas: false
  });

  const [l_09_12, setL_09_12] = useState([]);
  const [l_15_17, setL_15_17] = useState([]);
  const [l_17_22, setL_17_22] = useState([]);


  //---------------------------------------------------------------------------
  // création des listes de postes pour les créneaux du vendredi
  //---------------------------------------------------------------------------
  useEffect(() => {
    /*
    setL_09_12(data_vendredi.filter((ligne) => ligne[0] && ligne[0].trim().length > 0)
      .map((ligne) => `${ligne[0]} (${ligne[2]}/${ligne[3]})`));
    setL_15_17(data_vendredi.filter((ligne) => ligne[4] && ligne[4].trim().length > 0)
      .map((ligne) => `${ligne[4]} (${ligne[6]}/${ligne[7]})`));
    setL_17_22(data_vendredi.filter((ligne) => ligne[8] && ligne[8].trim().length > 0)
      .map((ligne) => `${ligne[8]} (${ligne[10]}/${ligne[11]})`));
    */
    setL_09_12(data_vendredi.map((ligne) => ligne[0]).filter(str => str.trim().length > 0));
    setL_15_17(data_vendredi.map((ligne) => ligne[4]).filter(str => str.trim().length > 0));
    setL_17_22(data_vendredi.map((ligne) => ligne[8]).filter(str => str.trim().length > 0));
  }, [data_vendredi]);

  //---------------------------------------------------------------------------
  // mise à jour des données dans le composant parent
  //---------------------------------------------------------------------------
  useEffect(() => {
    onVendrediChange(vendredi);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendredi]);

  //---------------------------------------------------------------------------
  // reset des info du vendredi
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (triggerResetVendredi) {
      setVendredi({
        c_09_12: '',
        c_15_17: '',
        c_17_22: '',
        repas: false
      });
    }
  }, [triggerResetVendredi]);

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Stack spacing={1} bgcolor={'#b5e3e8'} alignItems={'center'} sx={{ width: '100%' }}>
      <Typography variant="h5" align="center">
        Vendredi
      </Typography>

      <SelectPoste
        label="09h00-12h00"
        value={vendredi.c_09_12}
        onChange={(event) => { setVendredi({ ...vendredi, c_09_12: event.target.value }); }}
        items={l_09_12}
      />

      <SelectPoste
        label="15h00-17h00"
        value={vendredi.c_15_17}
        onChange={(event) => { setVendredi({ ...vendredi, c_15_17: event.target.value }); }}
        items={l_15_17}
      />

      <SelectPoste
        label="17h00-22h00"
        value={vendredi.c_17_22}
        onChange={(event) => { setVendredi({ ...vendredi, c_17_22: event.target.value }); }}
        items={l_17_22}
      />
      <Stack spacing={1} bgcolor={'#e69138'} alignItems={'center'} sx={{ width: '100%' }}>
        <FormControlLabel
          label="Repas bénévoles vendredi soir"
          control={
            <Checkbox
              checked={vendredi.repas}
              onChange={(event) => { setVendredi({ ...vendredi, repas: event.target.checked }); }}
            />} />
      </Stack>
    </Stack>

  );
};

Vendredi.propTypes = {
  data_vendredi: PropTypes.any.isRequired,
  onVendrediChange: PropTypes.any.isRequired,
  triggerResetVendredi: PropTypes.any.isRequired
};

export default Vendredi;